import React from 'react';
import gold_logo from '../../assets/images/gold_logo.png';
import './home-styles/home-section6.scss';
import { FaFacebookF, FaInstagram, FaYoutube, FaLinkedinIn, FaPhoneAlt, FaHome } from 'react-icons/fa';

const HomeSection6 = () => {
    return (
        <div className='home-section6'>
            <div className='section dark-section'>
                <div className='row'>
                    {/* Left Side: Logo + Social Icons */}
                    <div className='col-12 col-md-6 log-section'>
                        <img src={gold_logo} alt="Gold Logo" className="gold-logo" />
                        <div className='communication-icons'>
                            <div className='social-icons'>
                                <a href="https://www.facebook.com/share/g/16G4cXpKTw/" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
                                <a href="https://www.instagram.com/bfgappraisertrainingcentre?igsh=MnJ0ZjdlZ3kxYmM0" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
                                <a href="https://youtube.com" target="_blank" rel="noopener noreferrer"><FaYoutube /></a>
                                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a>
                            </div>
                        </div>
                    </div>

                    {/* Right Side: Contact Info */}
                    <div className='col-12 col-md-6 address-section'>
                        <div className='contact-box'>
                            <h3>Contact Us</h3>

                            <div className='contact-item'>
                                <FaPhoneAlt className='icon' />
                                <div>
                                    <strong>Phone</strong>
                                    <p>+91 7871051549</p>
                                </div>
                            </div>

                            <div className='contact-item'>
                                <FaHome className='icon' />
                                <div>
                                    <strong>Address</strong>
                                    <p>
                                        71, Pillayar Kovil Street,<br />
                                        Opposite Rajendran Hotel,<br />
                                        Javulikadai Bustop, 30 Feet Road,<br />
                                        Gugai, Salem,<br />
                                        Tamil Nadu - 636006
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                 <div className="bottom-line" />
            </div>
        </div>
    );
};

export default HomeSection6;
